var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroupWhite2020 = function SvgGroupWhite2020(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "group_white_20_20_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#group_white_20_20_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.833 16.667v-2.334q0-.708.365-1.302a2.43 2.43 0 0 1 .969-.906 12.4 12.4 0 0 1 2.625-.969 11.5 11.5 0 0 1 2.708-.323q1.376 0 2.708.323 1.334.322 2.625.969.604.312.969.906t.365 1.302v2.334zm15 0v-2.5q0-.917-.51-1.76-.51-.845-1.448-1.449 1.062.126 2 .427.937.303 1.75.74.75.417 1.146.927t.396 1.115v2.5zM7.5 10a3.2 3.2 0 0 1-2.354-.98 3.2 3.2 0 0 1-.98-2.353q0-1.376.98-2.354a3.2 3.2 0 0 1 2.354-.98 3.2 3.2 0 0 1 2.354.98 3.2 3.2 0 0 1 .98 2.354 3.2 3.2 0 0 1-.98 2.354A3.2 3.2 0 0 1 7.5 10m8.333-3.333a3.2 3.2 0 0 1-.979 2.354A3.2 3.2 0 0 1 12.5 10a4 4 0 0 1-.583-.052 5 5 0 0 1-.584-.115q.562-.666.865-1.479a4.8 4.8 0 0 0 .302-1.687q0-.875-.302-1.688a5 5 0 0 0-.865-1.479q.293-.105.584-.135.291-.032.583-.032a3.2 3.2 0 0 1 2.354.98 3.2 3.2 0 0 1 .98 2.354"
  }))));
};
export default SvgGroupWhite2020;